import React, { useState, useEffect, useRef } from "react";
import DurationDropDownMenu from "../duration-drop-down";
import InputRangeSlider from "../input-range-slider";
import DatePicker from "react-datepicker";
import CONFIG_OBJECT from "../../../config/config";
import App_Constants from "../../../app-constants/App_Constants";
import { postDataFetcher } from "../../../dataFetcher";
import DefaultCalendar from "../DefaultCalendar/DefaultCalendar";
import Paginator from "../period-calculator-result/Paginator";
import SetReminders from "../set-reminders";
import PredictPhase from "../predict-phase";
import { isMobile } from "react-device-detect";
import OutsideAlerter from "../outside-alerter/outsideAlerter";
import "../period-calculator-css/period-calculator.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Stepper, Step } from "react-form-stepper";
import { registerLocale } from "react-datepicker";
import enIN from "date-fns/locale/en-IN";

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";

registerLocale("enIN", enIN);

let currentMonthCycle = {
  dayValue: new Date().getDate(),
  duration: "",
  period: "",
};

const TrackMyPeriod = (props) => {
  let firstDayOfLastPeriod = "FirstDayOfLastPeriod";
  let averagePeriodDuration = "AveragePeriodDuration";
  let daysBetweenPeriods = "DaysBetweenPeriods";
  let initialValue = "NAN";

  const { t } = props;
  const [
    displayAveragePeriodDurationDropDown,
    setAveragePeriodDurationDropDown,
  ] = useState(false);
  const [displayDaysBetweenPeriod, setDisplayDaysBetweenPeriod] =
    useState(false);
  const [enablenext, setenablenext] = useState(false);
  const [showPreviousMonths, setShowPreviousMonths] = useState(true);
  const [showSelectedValue, setshowSelectedValue] = useState(false);
  const [disableTrackNow, setDisableTrackNow] = useState(true);
  const [stepperlastPeriodFirstday, setstepperlastPeriodFirstday] =
    useState(false);
  const [divlastPeriodFirstday, setdivlastPeriodFirstday] = useState(true);
  const [divdaysBetweenPeriod, setdivdaysBetweenPeriod] = useState(false);
  const [divperiodDuration, setdivperiodDuration] = useState(false);
  const [periodDuration, setPeriodDuration] = useState(initialValue);
  const [daysBetweenPeriod, setDaysBetweenPeriod] = useState(initialValue);
  const [lastPeriodFirstday, setlastPeriodFirstday] = useState(initialValue);

  const [showDefaultCalender, setShowDefaultCalender] = useState(true);
  const [showAllMonths, setShowAllMonths] = useState(true);
  const [showFertileDays, setShowFertileDays] = useState(false);
  const [showPeriodDays, setShowPeriodDays] = useState(false);
  const [showPredictPhase, setShowPredictPhase] = useState(false);
  const [showOvulationDays, setShowOvulationDays] = useState(false);

  const [toggleDatePicker, setToggleDatePicker] = useState(false);
  const [apiStateChange, setApiStateChange] = useState(false);
  const [iconDictionary, setIconDictionary] = useState("");

  const [validApiData, setValidApiData] = useState(false);
  const [apiData, setApiData] = useState("");
  const [isTrackNow, setisTrackNow] = useState(false);
  const [tracknowClick, settracknowCkick] = useState(false);
  const [apiDataAllDays, setApiDataAllDays] = useState({
    months: "",
    legends: "",
  });
  const [apiDataPeriodAndOvulation, setApiDataPeriodAndOvulation] = useState({
    months: "",
    legends: "",
  });
  const [apiDataPeriodAndFertile, setApiDataPeriodAndFertile] = useState({
    months: "",
    legends: "",
  });
  const [apiDataOvulationandFertile, setApiDataOvulationAndFertile] = useState({
    months: "",
    legends: "",
  });
  const [apiDataPredictPhase, setApiDataPredictPhase] = useState({
    months: "",
    legends: "",
  });

  const [predictPhaseResponse, setPredictPhaseResponse] = useState(null);
  const [predictPhaseFromDate, setPredictPhaseFromDate] = useState(null);
  const [predictPhaseToDate, setPredictPhaseToDate] = useState(null);
  const [startoverclick, setstartoverclick] = useState(true);
  const [updatevalue, setupdatevalue] = useState(false);
  const [show, setShow] = useState(false);
  const [lastPeriodSelection, setLastPeriodSelection] = useState(true);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (predictPhaseResponse != null) {
      if (predictPhaseFromDate != null) {
        let allPeriodMonths = [apiData.periodDays.months].flat(3);

        let maxDate =
          allPeriodMonths != null
            ? allPeriodMonths[allPeriodMonths.length - 1].dates.length === 0
              ? new Date(
                  allPeriodMonths[allPeriodMonths.length - 2].year,
                  allPeriodMonths[allPeriodMonths.length - 2].monthIndex,
                  new Date(
                    allPeriodMonths[allPeriodMonths.length - 2].year,
                    allPeriodMonths[allPeriodMonths.length - 2].monthIndex,
                    1
                  ).getDate() - 1
                )
              : new Date(
                  allPeriodMonths[allPeriodMonths.length - 1].year,
                  allPeriodMonths[allPeriodMonths.length - 1].monthIndex,
                  new Date(
                    allPeriodMonths[allPeriodMonths.length - 1].year,
                    allPeriodMonths[allPeriodMonths.length - 1].monthIndex,
                    1
                  ).getDate() - 1
                )
            : new Date(new Date().getFullYear(), new Date().getMonth() + 11, 1);

        let monthsInfo = [];
        let selectedFromDate = new Date(predictPhaseFromDate);
        let selectedToDate = null;

        if (predictPhaseToDate != null) {
          selectedToDate = new Date(predictPhaseToDate);
          selectedToDate.setHours(0, 0, 0, 0);
          if (selectedToDate.getMonth() - selectedFromDate.getMonth() > 1) {
            selectedFromDate = new Date(
              selectedFromDate.getFullYear(),
              selectedFromDate.getMonth() + 1,
              1
            );
            selectedFromDate.setHours(0, 0, 0, 0);
          }
        }

        let currentMonth = selectedFromDate;

        if (selectedFromDate.getMonth() === maxDate.getMonth()) {
          currentMonth = new Date(
            selectedFromDate.getFullYear(),
            selectedFromDate.getMonth() - 1,
            1
          );
        } else if (
          (selectedToDate != null &&
            selectedFromDate != null &&
            (Math.abs(
              selectedToDate.getMonth() + 1 - (selectedFromDate.getMonth() + 1)
            ) === 2 ||
              Math.abs(
                selectedToDate.getMonth() +
                  1 -
                  (selectedFromDate.getMonth() + 1)
              ) === 10)) ||
          new Date(lastPeriodFirstday).getMonth() === currentMonth.getMonth()
        ) {
          currentMonth = new Date(
            selectedFromDate.getFullYear(),
            selectedFromDate.getMonth() + 1,
            1
          );
        }
        if (
          isMobile &&
          selectedFromDate.getMonth() > new Date(lastPeriodFirstday).getMonth()
        ) {
          currentMonth = new Date(
            selectedFromDate.getFullYear(),
            selectedFromDate.getMonth() + 1,
            1
          );
        }
        let previousMonth = new Date(
          currentMonth.getFullYear(),
          currentMonth.getMonth() - 1,
          1
        );
        let nextMonth = new Date(
          currentMonth.getFullYear(),
          currentMonth.getMonth() + 1,
          1
        );
        let requiredPeriodMonths = [previousMonth, currentMonth, nextMonth];
        for (let i = 0; i < requiredPeriodMonths.length; i++) {
          let currentDates = requiredPeriodMonths[i];
          for (let j = 0; j < allPeriodMonths.length; j++) {
            let nextDates = allPeriodMonths[j];
            if (
              currentDates.getMonth() === nextDates.monthIndex - 1 &&
              currentDates.getFullYear() === nextDates.year
            ) {
              let mixedDates = {
                dates: [nextDates.dates].flat(1),
                monthIndex: nextDates.monthIndex,
                monthName: nextDates.monthName,
                year: nextDates.year,
              };
              monthsInfo.push(mixedDates);
            }
          }
        }

        let selectedDate = new Date(predictPhaseFromDate);
        selectedDate.setHours(0, 0, 0, 0);
        let isPeriodDay = false;
        let addNormalDayLegend = false;

        monthsInfo.forEach((month) => {
          month.dates.forEach((date) => {
            date.predictPhasePeriodDay = false;
            date.predictPhaseNormalDay = false;
          });
        });

        if (selectedToDate === null) {
          monthsInfo.forEach((month) => {
            if (month.monthIndex - 1 === selectedDate.getMonth()) {
              month.dates.forEach((date) => {
                if (date.day === selectedDate.getDate()) {
                  date.predictPhasePeriodDay = true;
                  date.predictPhaseNormalDay = false;
                  isPeriodDay = true;
                }
              });
            }
          });
          if (!isPeriodDay) {
            monthsInfo.forEach((month) => {
              if (month.monthIndex - 1 === selectedDate.getMonth()) {
                month.dates.push({
                  predictPhaseNormalDay: true,
                  predictPhasePeriodDay: false,
                  day: selectedDate.getDate(),
                  dayDescription: "Period Days",
                });
                addNormalDayLegend = true;
              }
            });
          }
        } else {
          monthsInfo.forEach((month) => {
            if (
              month.monthIndex - 1 >= selectedDate.getMonth() &&
              month.monthIndex - 1 <= selectedToDate.getMonth()
            ) {
              month.dates.forEach((date) => {
                let dateInLoop = new Date(
                  month.year,
                  month.monthIndex - 1,
                  Number(date.day)
                );
                if (
                  dateInLoop >= selectedDate &&
                  dateInLoop <= selectedToDate
                ) {
                  date.predictPhasePeriodDay = true;
                  date.predictPhaseNormalDay = false;
                  date.day = dateInLoop.getDate();
                  date.dayDescription = "Period Days";
                }
              });
            }
          });
          let fromDate = selectedDate;
          while (fromDate <= selectedToDate) {
            let periodDatesArray = [];
            monthsInfo.forEach((month) => {
              if (month.monthIndex - 1 === fromDate.getMonth()) {
                month.dates.forEach((date) => {
                  let dateInLoop = new Date(
                    month.year,
                    month.monthIndex - 1,
                    Number(date.day)
                  );
                  periodDatesArray.push(dateInLoop);
                });

                if (!periodDatesArray.includes(fromDate)) {
                  month.dates.push({
                    predictPhaseNormalDay: true,
                    predictPhasePeriodDay: false,
                    day: fromDate.getDate(),
                  });
                  addNormalDayLegend = true;
                }
              }
            });
            fromDate = new Date(
              new Date(fromDate).getFullYear(),
              new Date(fromDate).getMonth(),
              new Date(fromDate).getDate() + 1
            );
          }
        }

        let allLegends = [apiData.periodDays.legends].flat(1);
        if (addNormalDayLegend) {
          allLegends.push({
            title: props.dictionary("PeriodCalculator_DatesUnderConsideration"),
            colorCode: "#00000030",
          });
        }

        setApiDataPredictPhase({
          months: monthsInfo,
          legends: allLegends,
        });
        setApiStateChange(true);
        setShowPredictPhase(true);
      }
    } else {
      setPredictPhaseFromDate(null);
      setPredictPhaseToDate(null);
      setApiDataPredictPhase(null);
      setShowPredictPhase(false);
      if (apiData.periodDays != null) {
        let allPeriodMonths = [apiData.periodDays.months].flat(3);
        for (let j = 0; j < allPeriodMonths.length; j++) {
          let nextDates = allPeriodMonths[j];
          nextDates.dates.forEach((date) => {
            date.predictPhaseNormalDay = false;
            date.predictPhasePeriodDay = false;
          });
        }
      }
    }
  }, [predictPhaseResponse, predictPhaseFromDate, predictPhaseToDate]);

  useEffect(() => {
    let iconsDictionary = {};
    if (props.iconList != null) {
      props.iconList.map((icon) => {
        let new_key = icon.fields["Icon Name"].value;
        let new_value =
          icon.fields.Image != null && icon.fields.Image.value != null
            ? icon.fields.Image.value.src
            : "";
        iconsDictionary[new_key] = new_value;
      });
      setIconDictionary(iconsDictionary);
    }
  }, []);

  const [displayPredictPhase, setDisplayPredictPhase] = useState(false);

  const FirstDayOfLastPeriod = (event) => {
    event.preventDefault();
    setLastPeriodSelection(false); // hide Last Period Selection
    setShow(true); // open dialog
    if (isMobile) {
      setToggleDatePicker(true);
    }
    props.hidethirddiv(true);
    if (!stepperlastPeriodFirstday) {
      setstepperlastPeriodFirstday(true);
    }
    if (displayAveragePeriodDurationDropDown) {
      setAveragePeriodDurationDropDown(false);
    }
    if (displayDaysBetweenPeriod) {
      setDisplayDaysBetweenPeriod(false);
    }
    setstartoverclick(false);
    if (!isMobile) {
      setToggleDatePicker((prev) => !prev);
      if (lastPeriodFirstday === initialValue && !toggleDatePicker) {
        setlastPeriodFirstday(new Date());
      }
    }
  };

  const AveragePeriodDuration = (event) => {
    event.preventDefault();
    if (toggleDatePicker) {
      setToggleDatePicker(false);
    }
    if (displayDaysBetweenPeriod) {
      setDisplayDaysBetweenPeriod(false);
    }
    setAveragePeriodDurationDropDown((prev) => !prev);
    setisTrackNow(true);
    setstepperlastPeriodFirstday(false);
  };

  const DaysBetweenPeriods = (event) => {
    event.preventDefault();
    if (displayAveragePeriodDurationDropDown) {
      setAveragePeriodDurationDropDown(false);
    }
    if (toggleDatePicker) {
      setToggleDatePicker(false);
    }
    setDisplayDaysBetweenPeriod((prev) => !prev);
  };

  const FirstDayOfLastPeriodChange = (date) => {
    // debugger;
    if (!updatevalue) {
      setlastPeriodFirstday(date);
      setShowPreviousMonths(false);
      // setdivlastPeriodFirstday(false); // hiding 1st setp
      // setdivperiodDuration(true); // showing 2nd step
      setdivdaysBetweenPeriod(false); // hiding 3rd step
      // setstepperlastPeriodFirstday(false);
      setenablenext(true);
      setenablecaloutsideclick(false);
    } else if (updatevalue) {
      setlastPeriodFirstday(date);
      setShowPreviousMonths(false);
      setdivlastPeriodFirstday(true);
      setToggleDatePicker(true);
      setstepperlastPeriodFirstday(true);
    }
  };

  const TrackNowClick = () => {
    if (disableTrackNow) {
      return;
    }
    if (isMobile) {
      props.hidethirddiv(false);
      setShow(false);
      setDisableTrackNow(true);
      setShowPreviousMonths(false);
      setdivlastPeriodFirstday(false);
      setdivperiodDuration(false);
      setdivdaysBetweenPeriod(false);
      setstepperlastPeriodFirstday(false);
      setisTrackNow(true); // filter missing fixed in mobile
      setIsUpdate(true); // enabling popup close for update item
      // setting up footer non fixed
      let footer = document.getElementsByClassName("periodcal-disclaimer")[0];
      footer.style.position = "relative";
    }
    if (displayAveragePeriodDurationDropDown) {
      setAveragePeriodDurationDropDown(false);
    }
    if (displayDaysBetweenPeriod) {
      setDisplayDaysBetweenPeriod(false);
    }
    setshowSelectedValue(true);
    props.isTrackNowClick(true);

    let data = {
      lastPeriodDate: `${
        lastPeriodFirstday.getMonth() + 1
      }-${lastPeriodFirstday.getDate()}-${lastPeriodFirstday.getFullYear()}`,
      periodDuration: Number(periodDuration),
      cycleLength: Number(daysBetweenPeriod),
    };

    currentMonthCycle = {
      dayValue: `${lastPeriodFirstday.getDate()} ${lastPeriodFirstday.toLocaleString(
        "default",
        { month: "short" }
      )},${lastPeriodFirstday.getFullYear()}`,
      duration: Number(periodDuration),
      period: Number(daysBetweenPeriod),
    };

    setshowSelectedValue(true);
    postDataFetcher(
      `${CONFIG_OBJECT.PERIOD_CALCULATOR_ALLDAYS_REST_URL}${
        App_Constants.SC_API_KEY
      }&sc_lang=${localStorage.getItem("language")}`,
      data
    ).then(
      (res) => {
        if (res.data.HasError) {
        } else {
          setApiData(res.data.Data);
          setValidApiData(true);
          setDisplayPredictPhase(true);
          setApiStateChange(true);
          setDisableTrackNow(true);
          setPredictPhaseResponse(null);
          settracknowCkick(true);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    if (
      !isMobile &&
      periodDuration != initialValue &&
      daysBetweenPeriod != initialValue &&
      lastPeriodFirstday != initialValue
    ) {
      setDisableTrackNow(false);
    } else if (isMobile) {
      // setDisableTrackNow(false);
    }
  }, [periodDuration, daysBetweenPeriod, lastPeriodFirstday]);

  const MergeAllMonthsTogether = (allMonthsTogether) => {
    // merge all months data together
    let monthsInformation = [];
    allMonthsTogether.forEach((item) => {
      let existing = monthsInformation.filter((v, i) => {
        return v.monthName == item.monthName && v.year == item.year;
      });

      if (existing.length) {
        let existingIndex = monthsInformation.indexOf(existing[0]);
        monthsInformation[existingIndex].dates = monthsInformation[
          existingIndex
        ].dates.concat(item.dates);
      } else {
        monthsInformation.push(item);
      }
    });
    monthsInformation.map((data, i) => {
      // remove infertile and semi fertile days color code
      if (data.dates.length > 0 && data != null) {
        data.dates.map((item, x) => {
          if (
            item.dayDescription === "Semi Fertile Days" ||
            item.dayDescription === "Infertile Days"
          ) {
            item.colorCode = null;
          }
        });
      }
    });
    return monthsInformation;
  };

  // const MergeApiData = (allMonthsTogether, mergeFertileDays) => {
  //   debugger;
  //   let monthsInfo = [];
  //   for (let i = 0; i < allMonthsTogether.length; i++) {
  //     let currentDates = allMonthsTogether[i];
  //     let dateExists = false;

  //     monthsInfo.map((dates) => {
  //       if (
  //         dates.monthIndex === currentDates.monthIndex &&
  //         dates.year === currentDates.year
  //       ) {
  //         dateExists = true;
  //       }
  //     });

  //     if (!dateExists) {
  //       for (let j = i + 3; j < allMonthsTogether.length; j++) {
  //         let nextDates = allMonthsTogether[j];

  //         if (
  //           currentDates.monthIndex === nextDates.monthIndex &&
  //           currentDates.year === nextDates.year
  //         ) {
  //           let mixedDates = {
  //             dates: [currentDates.dates, nextDates.dates].flat(1),
  //             monthIndex: currentDates.monthIndex,
  //             monthName: currentDates.monthName,
  //             year: currentDates.year,
  //           };
  //           if (mixedDates.dates.length > 0) monthsInfo.push(mixedDates);
  //         }
  //       }
  //     }
  //   }

  //   let periodDays = apiData.periodDays.months.flat(3);
  //   let periodItemsCount = periodDays.length;
  //   let fertileDays = apiData.fertileDays.months.flat(3);
  //   let fertileItemsCount = fertileDays.length;
  //   if (periodItemsCount != fertileItemsCount && mergeFertileDays) {
  //     while (fertileItemsCount > periodItemsCount) {
  //       let fertileDates = fertileDays[fertileItemsCount - 1];
  //       monthsInfo.push(fertileDates);
  //       fertileItemsCount--;
  //     }
  //   }
  //   return monthsInfo;
  // };

  useEffect(() => {
    if (validApiData && apiStateChange) {
      setShowDefaultCalender(false);
      setApiStateChange(false);

      // all months data
      let allMonthsTogether = [
        apiData.periodDays.months,
        apiData.fertileDays.months,
        apiData.infertileDays.months,
        apiData.semiFertileDays.months,
      ].flat(3);
      let allMonths = JSON.parse(JSON.stringify(allMonthsTogether)); // creating new object to avoid copy of array data
      let monthsInfo = MergeAllMonthsTogether(allMonths);
      let allLegends = [
        apiData.periodDays.legends,
        apiData.fertileDays.legends,
      ].flat(1);

      setApiDataAllDays({
        months: monthsInfo,
        legends: allLegends,
      });

      //filters starts here
      // period and ovulation filter
      let periodAndOvulationMonths = [
        apiData.periodDays.months,
        apiData.ovulationDays.months,
      ].flat(3);
      let allPeriodAndOvulationMonthsTogether = JSON.parse(
        JSON.stringify(periodAndOvulationMonths)
      );
      let periodAndOvulationDaysInfo = MergeAllMonthsTogether(
        allPeriodAndOvulationMonthsTogether
      );
      let periodAndOvulationLegends = [
        apiData.periodDays.legends,
        apiData.ovulationDays.legends,
      ].flat(1);

      setApiDataPeriodAndOvulation({
        months: periodAndOvulationDaysInfo,
        legends: periodAndOvulationLegends,
      });

      // period and fertile filter
      let periodAndFertileMonths = [
        apiData.periodDays.months,
        apiData.fertileDays.months,
      ].flat(3);
      let allPeriodAndFertileMonthsTogether = JSON.parse(
        JSON.stringify(periodAndFertileMonths)
      );
      let periodAndFertileMonthsInfo = MergeAllMonthsTogether(
        allPeriodAndFertileMonthsTogether
      );
      let periodAndFertileLegends = [
        apiData.periodDays.legends,
        apiData.fertileDays.legends,
      ].flat(1);

      setApiDataPeriodAndFertile({
        months: periodAndFertileMonthsInfo,
        legends: periodAndFertileLegends,
      });

      // ovulation and fertile filter
      let ovulationAndFertileMonths = [
        apiData.ovulationDays.months,
        apiData.fertileDays.months,
      ].flat(3);
      let allOvulationAndFertileMonthsTogether = JSON.parse(
        JSON.stringify(ovulationAndFertileMonths)
      );
      let ovulationAndFertileMonthsInfo = MergeAllMonthsTogether(
        allOvulationAndFertileMonthsTogether
      );
      let ovulationAndFertileLegends = [apiData.fertileDays.legends].flat(1);

      setApiDataOvulationAndFertile({
        months: ovulationAndFertileMonthsInfo,
        legends: ovulationAndFertileLegends,
      });
    }
  });

  const showAllDaysChange = () => {
    // all days filter
    if (!showPredictPhase && !showAllMonths) {
      if (showOvulationDays) {
        setShowOvulationDays(false);
      }
      if (showFertileDays) {
        setShowFertileDays(false);
      }
      if (showPeriodDays) {
        setShowPeriodDays(false);
      }
      setShowAllMonths((prev) => !prev);
    } else {
      setShowPredictPhase(false);
      setShowAllMonths(true);
      setShowPeriodDays(false);
      setShowOvulationDays(false);
      setShowFertileDays(false);
    }
  };

  const periodDaysChange = () => {
    // period days filter
    if (!showPredictPhase) {
      if (showPeriodDays && !showOvulationDays && !showFertileDays) {
        setShowAllMonths(true);
      } else if (showAllMonths) {
        setShowAllMonths(false);
      }
      if (isMobile) {
        setShowPeriodDays(periodFilter);
      } else {
        setShowPeriodDays((prev) => !prev);
      }
      setShowPredictPhase(false);
    } else {
      setPredictPhaseResponse(null);
      setShowPredictPhase(false);
      setShowAllMonths(false);
      setShowPeriodDays(true);
      setShowOvulationDays(false);
      setShowFertileDays(false);
    }
  };

  const fertileDaysChange = () => {
    // fertile days filter
    if (!showPredictPhase) {
      if (!showPeriodDays && !showOvulationDays && showFertileDays) {
        setShowAllMonths(true);
      } else if (showAllMonths) {
        setShowAllMonths(false);
      }
      if (isMobile) {
        setShowFertileDays(fertileFilter);
      } else {
        setShowFertileDays((prev) => !prev);
      }
      setShowPredictPhase(false);
    } else {
      setShowPredictPhase(false);
      setShowAllMonths(false);
      setShowPeriodDays(false);
      setShowOvulationDays(false);
      setShowFertileDays(true);
    }
  };

  const ovulationDaysChange = () => {
    // ovulation days filter
    if (!showPredictPhase) {
      if (!showPeriodDays && showOvulationDays && !showFertileDays) {
        setShowAllMonths(true);
      } else if (showAllMonths) {
        setShowAllMonths(false);
      }
      if (isMobile) {
        setShowOvulationDays(ovulationFilter);
      } else {
        setShowOvulationDays((prev) => !prev);
      }
    } else {
      setShowPredictPhase(false);
      setShowAllMonths(false);
      setShowPeriodDays(false);
      setShowOvulationDays(true);
      setShowFertileDays(false);
    }
  };

  const [showFilterPopup, setShowFilterPopup] = useState(true);
  const showAllDaysMobileChange = () => {
    setShowFilterPopup((prev) => !prev);
  };

  const [allFilter, setAllFilter] = useState(true);
  const [periodFilter, setPeriodFilter] = useState(false);
  const [fertileFilter, setFertileFilter] = useState(false);
  const [ovulationFilter, setOvulationFilter] = useState(false);

  const [enablecaloutsideclick, setenablecaloutsideclick] = useState(true);
  const StartOver = (event) => {
    // setting up footer fixed
    let footer = document.getElementsByClassName("periodcal-disclaimer")[0];
    footer.style.position = "fixed";
    event.preventDefault();
    props.isTrackNowClick(false);
    setShow(false);
    setLastPeriodSelection(true); // show Last Period Selection
    setIsUpdate(false); // disable close popup for update
    setenablecaloutsideclick(false);
    setDurationDropDownOutSideClick(false);
    setIsClickedOutSide(false);
    setenablenext(false);
    setupdatevalue(false);
    setstartoverclick(true);
    setshowSelectedValue(false);
    setValidApiData(false);
    setApiData(null);
    setdivdaysBetweenPeriod(false);
    setdivperiodDuration(false);
    setdivlastPeriodFirstday(true);
    setPeriodDuration(initialValue);
    setlastPeriodFirstday(initialValue);
    setDaysBetweenPeriod(initialValue);
    setDisableTrackNow(true);
    settracknowCkick(false);
    setisTrackNow(false);
    props.hidethirddiv(false);
    setShowDefaultCalender(true);
  };

  const handleClosePopup = () => {
    setShow(false);
    props.hidethirddiv(false);
    setLastPeriodSelection(false);
    setshowSelectedValue(true);
    setDisableTrackNow(true);
    setdivdaysBetweenPeriod(false);
    setdivperiodDuration(false);
    if (!stepperlastPeriodFirstday) {
      setstepperlastPeriodFirstday(true);
    }
    if (displayAveragePeriodDurationDropDown) {
      setAveragePeriodDurationDropDown(false);
    }
    if (displayDaysBetweenPeriod) {
      setDisplayDaysBetweenPeriod(false);
    }
    setstartoverclick(false);
  };

  const [selectedFilter, setSelectedFilter] = useState(
    props.dictionary("PeriodCalculator_PredictPhaseFilterText")
  );
  const [isClickedOutSide, setIsClickedOutSide] = useState(false);
  const [durationDropDownOutSideClick, setDurationDropDownOutSideClick] =
    useState(false);

  const [inputRangeOutSideClick, setInputRangeOutSideClick] = useState(false);

  useEffect(() => {
    if (
      !isMobile &&
      isClickedOutSide &&
      (toggleDatePicker ||
        displayAveragePeriodDurationDropDown ||
        displayDaysBetweenPeriod)
    ) {
      if (toggleDatePicker) {
        setToggleDatePicker(false);
      }
      if (displayAveragePeriodDurationDropDown) {
        setAveragePeriodDurationDropDown(false);
      }
      if (displayDaysBetweenPeriod) {
        setDisplayDaysBetweenPeriod(false);
      }
      setIsClickedOutSide(false);
    }
    if (isMobile) {
      if (durationDropDownOutSideClick && enablecaloutsideclick) {
        // debugger;
        setdivdaysBetweenPeriod(true);
        setdivperiodDuration(false);
        setDurationDropDownOutSideClick(false);
      }
      if (inputRangeOutSideClick) {
        setDisplayDaysBetweenPeriod(false);
        setInputRangeOutSideClick(false);
      }
    }
  });

  const mobileFilterSelection = () => {
    setPredictPhaseResponse(null);
    setShowFilterPopup(false);
    setShowPredictPhase(false);
    if (allFilter) {
      setShowAllMonths(true);
      setShowPeriodDays(false);
      setShowFertileDays(false);
      setShowOvulationDays(false);
    }
    if (periodFilter) {
      setShowAllMonths(false);
      setShowPeriodDays(true);
    } else {
      setShowPeriodDays(false);
    }
    if (fertileFilter) {
      setShowAllMonths(false);
      setShowFertileDays(true);
    } else {
      setShowFertileDays(false);
    }
    if (ovulationFilter) {
      setShowAllMonths(false);
      setShowOvulationDays(true);
    } else {
      setShowOvulationDays(false);
    }

    // if (allFilter && !fertileFilter && !periodFilter && !ovulationFilter) {
    //   setSelectedFilter(
    //     props.dictionary("PeriodCalculator_PredictPhaseAllDaysText")
    //   );
    // } else if (
    //   !allFilter &&
    //   fertileFilter &&
    //   !periodFilter &&
    //   !ovulationFilter
    // ) {
    //   setSelectedFilter(props.dictionary("PeriodCalculator_FertileDays"));
    // } else if (
    //   !allFilter &&
    //   !fertileFilter &&
    //   periodFilter &&
    //   !ovulationFilter
    // ) {
    //   setSelectedFilter(props.dictionary("PeriodCalculator_PeriodDays"));
    // } else if (
    //   !allFilter &&
    //   !fertileFilter &&
    //   !periodFilter &&
    //   ovulationFilter
    // ) {
    //   setSelectedFilter(props.dictionary("PeriodCalculator_OvulationDays"));
    // } else {
    //   setSelectedFilter(
    //     props.dictionary("PeriodCalculator_PredictPhaseAllDaysText")
    //   );
    // }
  };

  // action associated to mobile result section
  const updateDate = () => {
    setshowSelectedValue(false); // hide result section
    setShow(true); // show popup
    setToggleDatePicker(true); // showing defalut datepicker
    setdivlastPeriodFirstday(true);
    setDisableTrackNow(false);
    setupdatevalue(true);
    setstepperlastPeriodFirstday(true); // enabling stepper on click result 1st section
  };
  const updateDuration = () => {
    setshowSelectedValue(false); // hide result section
    setShow(true); // show popup
    setdivlastPeriodFirstday(false);
    setDisableTrackNow(false);
    setupdatevalue(true);
    setstepperlastPeriodFirstday(false);
    setdivperiodDuration(true);
  };
  const updatePeriod = () => {
    setshowSelectedValue(false); // hide result section
    setShow(true); // show popup
    setdivlastPeriodFirstday(false);
    setDisableTrackNow(false);
    setupdatevalue(true);
    setstepperlastPeriodFirstday(false);
    setdivdaysBetweenPeriod(true);
  };
  // stepper footer prevoius button
  const Previous = (event, reminderkey, reminderquestion) => {
    setIsClickedOutSide(false);
    setDurationDropDownOutSideClick(false);
    setInputRangeOutSideClick(false);
    if (reminderquestion == firstDayOfLastPeriod) {
      setdivlastPeriodFirstday(false);
      setdivperiodDuration(true);
      setdivdaysBetweenPeriod(false);
      setstepperlastPeriodFirstday(false);
    } else if (reminderquestion == averagePeriodDuration) {
      setdivlastPeriodFirstday(true);
      setdivperiodDuration(false);
      setdivdaysBetweenPeriod(false);
      setstepperlastPeriodFirstday(true);
      setenablenext(true);
    } else if (reminderquestion == daysBetweenPeriods) {
      setDisableTrackNow(true);
      setdivlastPeriodFirstday(false);
      setdivperiodDuration(true);
      setdivdaysBetweenPeriod(false);
      setstepperlastPeriodFirstday(false);
      setenablenext(true);
      setAveragePeriodDurationDropDown(false);
    }
  };
  // stepper footer next button
  const Next = (event, reminderkey, reminderquestion) => {
    setIsClickedOutSide(false);
    if (reminderquestion == firstDayOfLastPeriod) {
      setdivlastPeriodFirstday(false);
      setdivperiodDuration(true);
      setdivdaysBetweenPeriod(false);
      setstepperlastPeriodFirstday(false);
      // if (periodDuration == initialValue) {
      //   setenablenext(false);
      // }
    } else if (reminderquestion == averagePeriodDuration) {
      setdivlastPeriodFirstday(false);
      setdivperiodDuration(false);
      setdivdaysBetweenPeriod(true);
      setstepperlastPeriodFirstday(false);
      if (daysBetweenPeriod != initialValue) {
        setDisableTrackNow(false);
      } else {
        setenablenext(false);
      }
    }
  };
  const [closeAlldaysPopup, setCloseAlldayspopup] = useState(false);
  const [buttonOutsideClick, setButtonOutsideClick] = useState(false);

  useEffect(() => {
    if (isMobile && showFilterPopup && toggleDatePicker) {
      setShowFilterPopup(true);
    }
    if (closeAlldaysPopup && buttonOutsideClick) {
      setCloseAlldayspopup(false);
      setShowFilterPopup(false);
      setButtonOutsideClick(false);
    }
  });
  return (
    <>
      {props != null &&
        props.questionSet != null &&
        props.enabled &&
        !isMobile && (
          <>
            <OutsideAlerter setIsClickedOutSide={setIsClickedOutSide}>
              <div className="fourth-div">
                <div className="row">
                  {props.questionSet.map((question, index) => {
                    if (question.fields != null) {
                      return (
                        <div
                          className={
                            index === 0
                              ? "col-sm col1 question-hover"
                              : "col-sm question-hover"
                          }
                          key={index}
                        >
                          {question.fields.uniqueIdentifier != null && (
                            <a
                              className="track-my-period-anchor"
                              onClick={
                                question.fields.uniqueIdentifier.value ===
                                firstDayOfLastPeriod
                                  ? FirstDayOfLastPeriod
                                  : question.fields.uniqueIdentifier.value ===
                                    averagePeriodDuration
                                  ? AveragePeriodDuration
                                  : question.fields.uniqueIdentifier.value ===
                                    daysBetweenPeriods
                                  ? DaysBetweenPeriods
                                  : DaysBetweenPeriods
                              }
                            >
                              <p className="input">
                                {" "}
                                {question.fields.QuestionLabel.value}
                                <span
                                  className="fa fa-question-circle tool-tip-ques-icon help-tip"
                                  tool-tip-toggle="tooltip-demo"
                                  data-original-title={
                                    question.fields.QuestionToolTip.value
                                  }
                                >
                                  {question.fields.QuestionToolTip.value !=
                                    "" && (
                                    <p>
                                      {question.fields.QuestionToolTip.value}
                                    </p>
                                  )}
                                </span>
                              </p>
                              <span>
                                <img
                                  src={
                                    props.domain +
                                    question.fields.icon.value.src
                                  }
                                  className="input-images"
                                  alt={question.fields.icon.value.alt}
                                  width=""
                                />
                                {question.fields.uniqueIdentifier.value ===
                                  averagePeriodDuration && (
                                  <input
                                    id={question.fields.uniqueIdentifier.value}
                                    className="date-input"
                                    type="text"
                                    value={
                                      !isNaN(periodDuration)
                                        ? periodDuration
                                        : question.fields["placeholder-text"]
                                            .value
                                    }
                                  />
                                )}
                                {question.fields.uniqueIdentifier.value ===
                                  daysBetweenPeriods && (
                                  <input
                                    id={question.fields.uniqueIdentifier.value}
                                    className="date-input"
                                    type="text"
                                    value={
                                      !isNaN(daysBetweenPeriod)
                                        ? daysBetweenPeriod
                                        : question.fields["placeholder-text"]
                                            .value
                                    }
                                  />
                                )}
                                {question.fields.uniqueIdentifier.value ===
                                  firstDayOfLastPeriod && (
                                  <>
                                    <DatePicker
                                      dateFormat="dd MMMM, yyyy"
                                      monthsShown={2}
                                      endDate={Date.now}
                                      showPopperArrow={false}
                                      locale="enIN"
                                      minDate={new Date().setDate(
                                        new Date().getDate() - 34
                                      )}
                                      maxDate={new Date()}
                                      showPreviousMonths={showPreviousMonths}
                                      placeholderText={
                                        question.fields["placeholder-text"]
                                          .value
                                      }
                                      onChange={FirstDayOfLastPeriodChange}
                                      selected={
                                        lastPeriodFirstday != initialValue
                                          ? lastPeriodFirstday
                                          : null
                                      }
                                      open={toggleDatePicker}
                                    />
                                  </>
                                )}
                              </span>
                            </a>
                          )}
                          {question.fields.uniqueIdentifier != null &&
                            question.fields.uniqueIdentifier.value ===
                              averagePeriodDuration &&
                            displayAveragePeriodDurationDropDown && (
                              <>
                                <DurationDropDownMenu
                                  periodDurationDefaults={
                                    props.periodDurationDefaults
                                  }
                                  periodDuration={periodDuration}
                                  setPeriodDuration={setPeriodDuration}
                                />
                              </>
                            )}
                          {question.fields.uniqueIdentifier != null &&
                            question.fields.uniqueIdentifier.value ===
                              daysBetweenPeriods &&
                            displayDaysBetweenPeriod && (
                              <>
                                <InputRangeSlider
                                  daysBetweenPeriodsDefaults={
                                    props.daysBetweenPeriodsDefaults
                                  }
                                  daysBetweenPeriod={daysBetweenPeriod}
                                  setDaysBetweenPeriod={setDaysBetweenPeriod}
                                  setDisplayDaysBetweenPeriod={
                                    setDisplayDaysBetweenPeriod
                                  }
                                />
                              </>
                            )}
                        </div>
                      );
                    }
                  })}
                  {props != null && props.questionSet != null && (
                    <div className="col-sm-2 col4 tracknow-submit">
                      <button
                        className={
                          disableTrackNow ? "tracknow" : "tracknow-enabled"
                        }
                        disabled={disableTrackNow}
                        onClick={TrackNowClick}
                      >
                        {props.submitLabel}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </OutsideAlerter>
            <p className="rollover-para">
              {!showDefaultCalender
                ? props.dictionary("PeriodCalculator_RolloverSpecificDays")
                : ""}
            </p>

            <div className="fifth-div">
              <div className="row">
                <div className="col-md-10">
                  <span className="options-heading">
                    {props.dictionary("PeriodCalculator_FilterBy")}
                  </span>
                  <span>
                    <div className="options-space">
                      <button
                        className={
                          showAllMonths && validApiData && !showPredictPhase
                            ? "view-options active-all"
                            : "view-options"
                        }
                        disabled={!validApiData}
                        id="results-all-days"
                        onClick={showAllDaysChange}
                      >
                        {selectedFilter}
                      </button>
                      <button
                        className={
                          !validApiData
                            ? "view-options bg-white"
                            : showPeriodDays && !showPredictPhase
                            ? "view-options period-option active-period"
                            : "view-options period-option"
                        }
                        id="results-period-days"
                        disabled={!validApiData}
                        onClick={periodDaysChange}
                      >
                        {props.dictionary("PeriodCalculator_PeriodDays")}
                      </button>
                      <button
                        className={
                          !validApiData
                            ? "view-options bg-white"
                            : showFertileDays && !showPredictPhase
                            ? "view-options fertile-option active-fertile"
                            : "view-options fertile-option"
                        }
                        id="results-fertile-days"
                        disabled={!validApiData}
                        onClick={fertileDaysChange}
                      >
                        {props.dictionary("PeriodCalculator_FertileWindow")}
                      </button>
                      <button
                        className={
                          !validApiData
                            ? "view-options bg-white"
                            : showOvulationDays && !showPredictPhase
                            ? "view-options ovulation-option active-ovulation"
                            : "view-options ovulation-option"
                        }
                        id="results-ovulation-days"
                        disabled={!validApiData}
                        onClick={ovulationDaysChange}
                      >
                        {props.dictionary("PeriodCalculator_OvulationDays")}
                      </button>
                    </div>
                  </span>
                </div>
                {!disableTrackNow ||
                  (validApiData && (
                    <PredictPhase
                      lastPeriodFirstday={lastPeriodFirstday}
                      periodDuration={periodDuration}
                      daysBetweenPeriod={daysBetweenPeriod}
                      calenderIcon={iconDictionary["calendarIcon"]}
                      setPredictPhaseResponse={setPredictPhaseResponse}
                      setPredictPhaseFromDate={setPredictPhaseFromDate}
                      setPredictPhaseToDate={setPredictPhaseToDate}
                      dictionary={props.dictionary}
                      showPredictPhase={showPredictPhase}
                      periodDaysResponse={[apiData.periodDays.months].flat(3)}
                    />
                  ))}
              </div>
            </div>
            <br />

            {showDefaultCalender && (
              <>
                <div className="row calendar-row">
                  <DefaultCalendar
                    date={
                      new Date(new Date().setMonth(new Date().getMonth() - 1))
                    }
                  />
                  <DefaultCalendar date={new Date()} />
                  <DefaultCalendar
                    date={
                      new Date(new Date().setMonth(new Date().getMonth() + 1))
                    }
                  />
                </div>
              </>
            )}

            {!showDefaultCalender &&
              showPredictPhase &&
              !apiStateChange &&
              predictPhaseResponse != null && (
                <>
                  <Paginator
                    result={apiDataPredictPhase}
                    trackMyPeriodKey={props.trackMyPeriodKey}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {!showDefaultCalender &&
              !apiStateChange &&
              showAllMonths &&
              !showPredictPhase && (
                <>
                  <Paginator
                    result={apiDataAllDays}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {!showDefaultCalender &&
              !showPredictPhase &&
              !apiStateChange &&
              showPeriodDays &&
              showFertileDays && (
                <>
                  <Paginator
                    result={apiDataPeriodAndFertile}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {!showDefaultCalender &&
              !showPredictPhase &&
              !apiStateChange &&
              showFertileDays &&
              showOvulationDays &&
              !showPeriodDays && (
                <>
                  <Paginator
                    result={apiDataOvulationandFertile}
                    trackMyPeriodKey={props.trackMyPeriodKey}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {!showDefaultCalender &&
              !showPredictPhase &&
              !apiStateChange &&
              showOvulationDays &&
              !showFertileDays &&
              showPeriodDays && (
                <>
                  <Paginator
                    result={apiDataPeriodAndOvulation}
                    showOvulationDays={showOvulationDays}
                    trackMyPeriodKey={props.trackMyPeriodKey}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {!showDefaultCalender &&
              !showPredictPhase &&
              !apiStateChange &&
              showFertileDays &&
              !showPeriodDays &&
              !showOvulationDays && (
                <>
                  <Paginator
                    result={apiData.fertileDays}
                    trackMyPeriodKey={props.trackMyPeriodKey}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {!showDefaultCalender &&
              !showPredictPhase &&
              !apiStateChange &&
              showPeriodDays &&
              !showFertileDays &&
              !showOvulationDays && (
                <>
                  <Paginator
                    result={apiData.periodDays}
                    trackMyPeriodKey={props.trackMyPeriodKey}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {!showDefaultCalender &&
              !showPredictPhase &&
              !apiStateChange &&
              showOvulationDays &&
              !showFertileDays &&
              !showPeriodDays && (
                <>
                  <Paginator
                    result={apiData.ovulationDays}
                    showOvulationDays={showOvulationDays}
                    trackMyPeriodKey={props.trackMyPeriodKey}
                    icons={iconDictionary}
                    dictionary={props.dictionary}
                  />
                </>
              )}

            {predictPhaseResponse !== null && showPredictPhase && (
              <div className="future-dates-result-section predict-phase-results-section">
                <div className="calendar" id="future-dates-response">
                  {predictPhaseResponse.length != 0 && (
                    <>
                      <div className="reminder-set">
                        {predictPhaseResponse.imageUrl != null && (
                          <img
                            src={`${props.domain}${predictPhaseResponse.imageUrl.src}`}
                            alt=""
                            className="future-dates-side-img"
                          />
                        )}
                      </div>
                      <div className="reminder-success">
                        <h5
                          className="reminder-success-msg"
                          style={{
                            color: predictPhaseResponse.isOnPeriod
                              ? "#DA291C"
                              : "#3C9941",
                          }}
                        >
                          {predictPhaseResponse.resultMessage}
                        </h5>
                      </div>
                      {predictPhaseResponse.periodDaysNote != null ? (
                        <>
                          <div className="future-period-days">
                            <h5 className="future-period-days-msg">
                              {predictPhaseResponse.periodDaysNote}
                            </h5>
                          </div>
                          {predictPhaseResponse.periodDays != null &&
                            predictPhaseResponse.periodDays.length > 0 &&
                            predictPhaseResponse.periodDays.map((periodDay, index) => {
                              return (
                                <div className="future-period-days" key={index}>
                                  <span>
                                    {periodDay.periodEndDate != ""
                                      ? `${periodDay.periodStartDate} - ${periodDay.periodEndDate}`
                                      : periodDay.periodStartDate}
                                  </span>
                                </div>
                              );
                            })}
                        </>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
            )}

            {!showPredictPhase && (
              <SetReminders
                validApiData={validApiData}
                lastPeriodFirstday={lastPeriodFirstday}
                periodDuration={periodDuration}
                daysBetweenPeriod={daysBetweenPeriod}
                reminderItems={props.setReminders}
                dictionary={props.dictionary}
                showAllMonths={showAllMonths}
                showPeriodDays={showPeriodDays}
                showFertileDays={showFertileDays}
                showOvulationDays={showOvulationDays}
              />
            )}
          </>
        )}

      {props != null && props.questionSet != null && props.enabled && isMobile && (
        <>
          {lastPeriodSelection && (
            <>
              {props.questionSet.map((question, index) => {
                if (question.fields != null && index === 0) {
                  return (
                    <>
                      <div className="fourth-div-reminders-tab top-padding" key={index}>
                        {question.fields.uniqueIdentifier != null && (
                          <div className="col-sm col1 question-hover div-other-reminders-mob text-center">
                            <a className="track-my-period-anchor">
                              <p className="input">
                                {" "}
                                {question.fields.QuestionLabel.value}
                                <span
                                  className="fa fa-question-circle tool-tip-ques-icon help-tip"
                                  tool-tip-toggle="tooltip-demo"
                                  data-original-title={
                                    question.fields.QuestionToolTip.value
                                  }
                                >
                                  {question.fields.QuestionToolTip.value !=
                                    "" && (
                                    <span>
                                      {question.fields.QuestionToolTip.value}
                                    </span>
                                  )}
                                </span>
                              </p>
                              <span>
                                <img
                                  src={
                                    props.domain +
                                    question.fields.icon.value.src
                                  }
                                  className="input-images"
                                  alt={question.fields.icon.value.alt}
                                  width=""
                                  onClick={
                                    question.fields.uniqueIdentifier.value ===
                                    firstDayOfLastPeriod
                                      ? FirstDayOfLastPeriod
                                      : question.fields.uniqueIdentifier
                                          .value === averagePeriodDuration
                                      ? AveragePeriodDuration
                                      : question.fields.uniqueIdentifier
                                          .value === daysBetweenPeriods
                                      ? DaysBetweenPeriods
                                      : DaysBetweenPeriods
                                  }
                                />
                                <a
                                  onClick={
                                    question.fields.uniqueIdentifier.value ===
                                    firstDayOfLastPeriod
                                      ? FirstDayOfLastPeriod
                                      : question.fields.uniqueIdentifier
                                          .value === averagePeriodDuration
                                      ? AveragePeriodDuration
                                      : question.fields.uniqueIdentifier
                                          .value === daysBetweenPeriods
                                      ? DaysBetweenPeriods
                                      : DaysBetweenPeriods
                                  }
                                >
                                  <span>
                                    {question.fields["placeholder-text"].value}
                                  </span>
                                </a>
                              </span>
                            </a>
                          </div>
                        )}
                      </div>
                    </>
                  );
                }
              })}
            </>
          )}
          <Modal
            className="modal-mobile-period-calc"
            show={show}
            animation={false}
          >
            <ModalBody>
              <div className="fourth-div-reminders-tab">
                {props.questionSet.map((question, index) => {
                  if (question.fields != null) {
                    return (
                      <>
                        <div // stepper heading
                          className={
                            question.fields.uniqueIdentifier.value ===
                            firstDayOfLastPeriod
                              ? divlastPeriodFirstday
                                ? "stepper-heading"
                                : "d-none"
                              : question.fields.uniqueIdentifier.value ===
                                averagePeriodDuration
                              ? divperiodDuration
                                ? "stepper-heading"
                                : "d-none"
                              : question.fields.uniqueIdentifier.value ===
                                daysBetweenPeriods
                              ? divdaysBetweenPeriod
                                ? "stepper-heading"
                                : "d-none"
                              : "d-none"
                          }
                          key={index}
                        >
                          {!startoverclick &&
                            !isUpdate && ( // stepper close
                              <a onClick={StartOver}>
                                <span className="fa fa-times"></span>
                              </a>
                            )}

                          {!startoverclick && isUpdate && (
                            <a onClick={handleClosePopup}>
                              <span className="fa fa-times"></span>
                            </a>
                          )}
                          {question.fields.uniqueIdentifier.value ===
                            firstDayOfLastPeriod && (
                            <>
                              <span>{question.fields.QuestionLabel.value}</span>
                            </>
                          )}
                          {question.fields.uniqueIdentifier.value ===
                            averagePeriodDuration && (
                            <>
                              <span>{question.fields.QuestionLabel.value}</span>
                            </>
                          )}
                          {question.fields.uniqueIdentifier.value ===
                            daysBetweenPeriods && (
                            <>
                              <span>{question.fields.QuestionLabel.value}</span>
                            </>
                          )}
                        </div>
                        {!startoverclick && (
                          <Stepper
                            id={
                              question.fields.uniqueIdentifier.value ===
                              firstDayOfLastPeriod
                                ? "StepperLastPeriod"
                                : question.fields.uniqueIdentifier.value ===
                                  averagePeriodDuration
                                ? "StepperPeriodDuration"
                                : question.fields.uniqueIdentifier.value ===
                                  daysBetweenPeriods
                                ? "StepperDaysBetweenPeriods"
                                : ""
                            }
                            className={
                              question.fields.uniqueIdentifier.value ===
                              firstDayOfLastPeriod
                                ? stepperlastPeriodFirstday
                                  ? "RFS-StepperContainer"
                                  : "d-none"
                                : question.fields.uniqueIdentifier.value ===
                                  averagePeriodDuration
                                ? divperiodDuration
                                  ? "RFS-StepperContainer"
                                  : "d-none"
                                : question.fields.uniqueIdentifier.value ===
                                  daysBetweenPeriods
                                ? divdaysBetweenPeriod
                                  ? "RFS-StepperContainer"
                                  : "d-none"
                                : "d-none"
                            }
                            steps={[
                              {
                                href: "",
                              },
                              {
                                href: "",
                              },
                              { label: "" },
                            ]}
                            activeStep={index}
                          />
                        )}
                        <div
                          className={
                            question.fields.uniqueIdentifier.value ===
                            firstDayOfLastPeriod
                              ? divlastPeriodFirstday
                                ? "col-sm border-0"
                                : "d-none"
                              : question.fields.uniqueIdentifier.value ===
                                averagePeriodDuration
                              ? divperiodDuration
                                ? ""
                                : "d-none"
                              : question.fields.uniqueIdentifier.value ===
                                daysBetweenPeriods
                              ? divdaysBetweenPeriod
                                ? "row"
                                : "d-none"
                              : "d-none"
                          }
                        >
                          {question.fields.uniqueIdentifier != null && // 1st step
                            question.fields.uniqueIdentifier.value ===
                              firstDayOfLastPeriod &&
                            divlastPeriodFirstday && (
                              <>
                                <a className="track-my-period-anchor">
                                  <div className="datepicker-dialog">
                                    <DatePicker
                                      dateFormat="dd MMMM, yyyy"
                                      monthsShown={1}
                                      locale="enIN"
                                      endDate={Date.now}
                                      showPopperArrow={false}
                                      minDate={new Date().setDate(
                                        new Date().getDate() - 34
                                      )}
                                      maxDate={new Date()}
                                      showPreviousMonths={showPreviousMonths}
                                      placeholderText={
                                        question.fields["placeholder-text"]
                                          .value
                                      }
                                      onChange={FirstDayOfLastPeriodChange}
                                      selected={
                                        lastPeriodFirstday != initialValue
                                          ? lastPeriodFirstday
                                          : null
                                      }
                                      open={toggleDatePicker}
                                      onInputClick={() => {
                                        setToggleDatePicker((prev) => !prev);
                                        if (
                                          lastPeriodFirstday === initialValue &&
                                          !toggleDatePicker
                                        ) {
                                          setlastPeriodFirstday(new Date());
                                        }
                                      }}
                                    />
                                  </div>
                                </a>
                              </>
                            )}
                          {question.fields.uniqueIdentifier != null && // 2nd step
                            question.fields.uniqueIdentifier.value ===
                              averagePeriodDuration &&
                            divperiodDuration && (
                              <>
                                <DurationDropDownMenu
                                  periodDurationDefaults={
                                    props.periodDurationDefaults
                                  }
                                  periodDuration={periodDuration}
                                  setPeriodDuration={setPeriodDuration}
                                  setdivperiodDuration={setdivperiodDuration}
                                  setdivdaysBetweenPeriod={
                                    setdivdaysBetweenPeriod
                                  }
                                  setenablecaloutsideclick={
                                    setenablecaloutsideclick
                                  }
                                  index={index}
                                />
                              </>
                            )}
                          {question.fields.uniqueIdentifier != null && // 3rd step
                            question.fields.uniqueIdentifier.value ===
                              daysBetweenPeriods && (
                              <>
                                <InputRangeSlider
                                  daysBetweenPeriodsDefaults={
                                    props.daysBetweenPeriodsDefaults
                                  }
                                  daysBetweenPeriod={daysBetweenPeriod}
                                  setDaysBetweenPeriod={setDaysBetweenPeriod}
                                  setdivperiodDuration={setdivperiodDuration}
                                  setdivdaysBetweenPeriod={
                                    setdivdaysBetweenPeriod
                                  }
                                  index={index}
                                  setDisplayDaysBetweenPeriod={
                                    setDisplayDaysBetweenPeriod
                                  }
                                  settracknowclick={settracknowCkick}
                                  // setDisableTrackNow={true}
                                />
                              </>
                            )}
                        </div>
                        {isMobile &&
                          !startoverclick && ( // stepper footer
                            <div
                              className={
                                question.fields.uniqueIdentifier.value ===
                                firstDayOfLastPeriod
                                  ? divlastPeriodFirstday
                                    ? "row stepper-footer"
                                    : "d-none"
                                  : question.fields.uniqueIdentifier.value ===
                                    averagePeriodDuration
                                  ? divperiodDuration
                                    ? "row stepper-footer"
                                    : "d-none"
                                  : question.fields.uniqueIdentifier.value ===
                                    daysBetweenPeriods
                                  ? divdaysBetweenPeriod
                                    ? "row stepper-footer"
                                    : "d-none"
                                  : "d-none"
                              }
                              data-disableclick="true"
                            >
                              <div className="col-6">
                                <div // Prev button
                                  className={
                                    index > 0 ? "" : "disable-prev d-none"
                                  }
                                  id="previousbutton"
                                  data-disableclick="true"
                                >
                                  <a
                                    className="next-other-reminder prev-other-reminder"
                                    onClick={Previous.bind(
                                      null,
                                      index,
                                      props.reminderKey,
                                      question.fields.uniqueIdentifier.value
                                    )}
                                    data-disableclick="true"
                                  >
                                    <i
                                      className="fa fa-arrow-left"
                                      data-disableclick="true"
                                    ></i>
                                    Previous
                                  </a>
                                </div>
                              </div>
                              <div // Next button
                                className={disableTrackNow ? "col-6" : "d-none"}
                                data-disableclick="true"
                              >
                                <a
                                  className={
                                    enablenext ? "tracknow-enabled" : "tracknow"
                                  }
                                  onClick={Next.bind(
                                    null,
                                    index,
                                    props.reminderKey,
                                    question.fields.uniqueIdentifier.value
                                  )}
                                  data-disableclick="true"
                                >
                                  Next
                                </a>
                              </div>
                              <div // Track now button
                                className={
                                  !disableTrackNow ? "col-6" : "d-none"
                                }
                                data-disableclick="true"
                              >
                                <div
                                  className="tracknow-submit"
                                  data-disableclick="true"
                                >
                                  <button
                                    className={"tracknow-enabled"}
                                    disabled={disableTrackNow}
                                    onClick={TrackNowClick}
                                  >
                                    {props.submitLabel}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                      </>
                    );
                  }
                })}
              </div>
            </ModalBody>
          </Modal>
          <div className="fourth-div-reminders-tab top-padding">
            {showSelectedValue && (
              <>
                <div className="col1-sm question-hover div-other-reminders-mob row track-my-period-result">
                  <div className="col-4 track-my-period-selcted-value px-2">
                    <a onClick={() => updateDate()}>
                      <p class="input">
                        FDLP{" "}
                        <i
                          className="fa fa-edit float-right mt-1"
                          aria-hidden="true"
                        />
                      </p>
                      <span className={"selected-value-div-font"}>
                        {currentMonthCycle.dayValue}
                      </span>
                    </a>
                  </div>
                  <div className="col-4 track-my-period-selcted-value px-2">
                    <a onClick={() => updateDuration()}>
                      <p class="input">
                        Period Duration{" "}
                        <i
                          className="fa fa-edit float-right mt-1"
                          aria-hidden="true"
                        />
                      </p>
                      <span className={"selected-value-div-font"}>
                        {currentMonthCycle.duration}{" "}
                        {currentMonthCycle.duration > 1 ? "Days" : "Day"}
                      </span>
                    </a>
                  </div>
                  <div className="col-4 px-2">
                    <a onClick={() => updatePeriod()}>
                      <p class="input">
                        Cycle Length{" "}
                        <i
                          className="fa fa-edit float-right mt-1"
                          aria-hidden="true"
                        />
                      </p>
                      <span className={"selected-value-div-font"}>
                        {currentMonthCycle.period} Days
                      </span>
                    </a>
                  </div>
                </div>
                <p className="info-div">
                  {!showDefaultCalender
                    ? "Tap on specific days for more information."
                    : ""}
                </p>
              </>
            )}
          </div>
          <div
            className={
              isTrackNow && !showDefaultCalender ? "fifth-div" : "d-none"
            }
          >
            <div className="row">
              <div className="col-12">
                <span className="options-heading">
                  {props.dictionary("PeriodCalculator_FilterBy")}
                </span>
                <span>
                  <div className="options-space">
                    <OutsideAlerter
                      className="predict-phase-button"
                      setIsClickedOutSide={setButtonOutsideClick}
                    >
                      <button
                        className={
                          showFilterPopup
                            ? "view-options view-options-clicked"
                            : "view-options"
                        }
                        disabled={!validApiData}
                        id="results-all-days"
                        onClick={showAllDaysMobileChange}
                      >
                        {props.dictionary(
                          "PeriodCalculator_PredictPhaseFilterText"
                        )}
                      </button>
                    </OutsideAlerter>
                    {showFilterPopup && (
                      <OutsideAlerter
                        className="options-block-mobile"
                        setIsClickedOutSide={setCloseAlldayspopup}
                      >
                        <input
                          type="checkbox"
                          className="reminders-checkbox-mobile"
                          onClick={() => {
                            setAllFilter((prev) => !prev);
                            if (!allFilter) {
                              setPeriodFilter(false);
                              setFertileFilter(false);
                              setOvulationFilter(false);
                            }
                          }}
                          checked={allFilter}
                        />
                        <span
                          onClick={() => {
                            setAllFilter((prev) => !prev);
                            if (!allFilter) {
                              setPeriodFilter(false);
                              setFertileFilter(false);
                              setOvulationFilter(false);
                            }
                          }}
                        >
                          {props.dictionary(
                            "PeriodCalculator_PredictPhaseAllDaysText"
                          )}
                        </span>
                        <div>
                          <input
                            type="checkbox"
                            className="reminders-checkbox-mobile"
                            onClick={() => {
                              setPeriodFilter((prev) => !prev);
                              if (!periodFilter) {
                                if (allFilter) setAllFilter(false);
                              }
                            }}
                            checked={periodFilter}
                          />
                          <span
                            onClick={() => {
                              setPeriodFilter((prev) => !prev);
                              if (!periodFilter) {
                                if (allFilter) setAllFilter(false);
                              }
                            }}
                          >
                            {props.dictionary("PeriodCalculator_PeriodDays")}
                          </span>
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            className="reminders-checkbox-mobile"
                            onClick={() => {
                              setFertileFilter((prev) => !prev);
                              if (!fertileFilter) {
                                if (allFilter) setAllFilter(false);
                              }
                            }}
                            checked={fertileFilter}
                          />
                          <span
                            onClick={() => {
                              setFertileFilter((prev) => !prev);
                              if (!fertileFilter) {
                                if (allFilter) setAllFilter(false);
                              }
                            }}
                          >
                            {props.dictionary("PeriodCalculator_FertileDays")}
                          </span>
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            className="reminders-checkbox-mobile"
                            onClick={() => {
                              setOvulationFilter((prev) => !prev);
                              if (!ovulationFilter) {
                                if (allFilter) setAllFilter(false);
                              }
                            }}
                            checked={ovulationFilter}
                          />
                          <span
                            onClick={() => {
                              setOvulationFilter((prev) => !prev);
                              if (!ovulationFilter) {
                                if (allFilter) setAllFilter(false);
                              }
                            }}
                          >
                            {props.dictionary("PeriodCalculator_OvulationDays")}
                          </span>
                        </div>
                        <div className="select-filter-div">
                          <div className="col-12">
                            <button
                              className={
                                !allFilter &&
                                !periodFilter &&
                                !fertileFilter &&
                                !ovulationFilter
                                  ? "select-filter-button-disabled"
                                  : "select-filter-button"
                              }
                              onClick={mobileFilterSelection}
                              disabled={
                                !allFilter &&
                                !periodFilter &&
                                !fertileFilter &&
                                !ovulationFilter
                              }
                            >
                              {props.dictionary(
                                "PeriodCalculator_PredictPhaseDone"
                              )}
                            </button>
                          </div>
                        </div>
                      </OutsideAlerter>
                    )}
                    {!disableTrackNow ||
                      (validApiData && (
                        <>
                          <PredictPhase
                            lastPeriodFirstday={lastPeriodFirstday}
                            periodDuration={periodDuration}
                            daysBetweenPeriod={daysBetweenPeriod}
                            calenderIcon={iconDictionary["calendarIcon"]}
                            setPredictPhaseResponse={setPredictPhaseResponse}
                            setPredictPhaseFromDate={setPredictPhaseFromDate}
                            setPredictPhaseToDate={setPredictPhaseToDate}
                            dictionary={props.dictionary}
                            setShowFilterPopup={setShowFilterPopup}
                            showFilterPopup={showFilterPopup}
                            showPredictPhase={showPredictPhase}
                            periodDaysResponse={[
                              apiData.periodDays.months,
                            ].flat(3)}
                          />
                        </>
                      ))}
                  </div>
                </span>
              </div>
            </div>
          </div>
          <br />

          {!showDefaultCalender && showPredictPhase && !apiStateChange && (
            <>
              <Paginator
                result={apiDataPredictPhase}
                trackMyPeriodKey={props.trackMyPeriodKey}
                icons={iconDictionary}
                dictionary={props.dictionary}
              />
            </>
          )}

          {!showDefaultCalender &&
            !showPredictPhase &&
            !apiStateChange &&
            showAllMonths && (
              <>
                <Paginator
                  result={apiDataAllDays}
                  icons={iconDictionary}
                  dictionary={props.dictionary}
                />
              </>
            )}

          {!showDefaultCalender &&
            !showPredictPhase &&
            !apiStateChange &&
            showPeriodDays &&
            showFertileDays && (
              <>
                <Paginator
                  result={apiDataPeriodAndFertile}
                  icons={iconDictionary}
                  dictionary={props.dictionary}
                />
              </>
            )}

          {!showDefaultCalender &&
            !showPredictPhase &&
            showFertileDays &&
            !apiStateChange &&
            showOvulationDays &&
            !showPeriodDays && (
              <>
                <Paginator
                  result={apiDataOvulationandFertile}
                  trackMyPeriodKey={props.trackMyPeriodKey}
                  icons={iconDictionary}
                  dictionary={props.dictionary}
                />
              </>
            )}

          {!showDefaultCalender &&
            !showPredictPhase &&
            showOvulationDays &&
            !apiStateChange &&
            !showFertileDays &&
            showPeriodDays && (
              <>
                <Paginator
                  result={apiDataPeriodAndOvulation}
                  showOvulationDays={showOvulationDays}
                  trackMyPeriodKey={props.trackMyPeriodKey}
                  icons={iconDictionary}
                  dictionary={props.dictionary}
                />
              </>
            )}

          {!showDefaultCalender &&
            !showPredictPhase &&
            showFertileDays &&
            !apiStateChange &&
            !showPeriodDays &&
            !showOvulationDays && (
              <>
                <Paginator
                  result={apiData.fertileDays}
                  trackMyPeriodKey={props.trackMyPeriodKey}
                  icons={iconDictionary}
                  dictionary={props.dictionary}
                />
              </>
            )}

          {!showDefaultCalender &&
            !showPredictPhase &&
            showPeriodDays &&
            !apiStateChange &&
            !showFertileDays &&
            !showOvulationDays && (
              <>
                <Paginator
                  result={apiData.periodDays}
                  trackMyPeriodKey={props.trackMyPeriodKey}
                  icons={iconDictionary}
                  dictionary={props.dictionary}
                />
              </>
            )}

          {!showDefaultCalender &&
            !showPredictPhase &&
            !apiStateChange &&
            showOvulationDays &&
            !showFertileDays &&
            !showPeriodDays && (
              <>
                <Paginator
                  result={apiData.ovulationDays}
                  showOvulationDays={showOvulationDays}
                  trackMyPeriodKey={props.trackMyPeriodKey}
                  icons={iconDictionary}
                  dictionary={props.dictionary}
                />
              </>
            )}

          {predictPhaseResponse !== null && showPredictPhase && (
            <div
              className={
                tracknowClick
                  ? "future-dates-result-section predict-phase-results-section"
                  : "d-none"
              }
            >
              <div className="calendar" id="future-dates-response">
                {predictPhaseResponse.length != 0 && (
                  <>
                    <div className="reminder-set">
                      {predictPhaseResponse.imageUrl != null && (
                        <img
                          src={`${props.domain}${predictPhaseResponse.imageUrl.src}`}
                          alt=""
                          className="future-dates-side-img"
                        />
                      )}
                    </div>
                    <div className="reminder-success">
                      <h5
                        className="reminder-success-msg"
                        style={{
                          color: predictPhaseResponse.isOnPeriod
                            ? "#DA291C"
                            : "#3C9941",
                        }}
                      >
                        {predictPhaseResponse.resultMessage}
                      </h5>
                    </div>
                    {predictPhaseResponse.periodDaysNote != null ? (
                      <>
                        <div className="future-period-days">
                          <h5 className="future-period-days-msg">
                            {predictPhaseResponse.periodDaysNote}
                          </h5>
                        </div>
                        {predictPhaseResponse.periodDays != null &&
                          predictPhaseResponse.periodDays.length > 0 &&
                          predictPhaseResponse.periodDays.map((periodDay, index) => {
                            return (
                              <div className="future-period-days" key={index}>
                                <span>
                                  {periodDay.periodEndDate != ""
                                    ? `${periodDay.periodStartDate} - ${periodDay.periodEndDate}`
                                    : periodDay.periodStartDate}
                                </span>
                              </div>
                            );
                          })}
                      </>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          )}

          {!showPredictPhase && (
            <SetReminders
              validApiData={validApiData}
              lastPeriodFirstday={lastPeriodFirstday}
              periodDuration={periodDuration}
              daysBetweenPeriod={daysBetweenPeriod}
              reminderItems={props.setReminders}
              dictionary={props.dictionary}
              showAllMonths={showAllMonths}
              showPeriodDays={showPeriodDays}
              showFertileDays={showFertileDays}
              showOvulationDays={showOvulationDays}
            />
          )}
          <div
            className={
              tracknowClick ? "form-mobile set-startover-button" : "d-none"
            }
          >
            <div>
              <a className="tracknow-enabled btn-default" onClick={StartOver}>
                Start Over
              </a>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TrackMyPeriod;
